<template>
  <div class="conflict-images-wrapper">
    <div class="image-columns">
      <!-- Yours -->
      <div class="image-set">
        <div class="set-header">
          <span class="set-title">Yours</span>
          <span class="set-count">
            {{ localCount }} image<span v-if="localCount !== 1">s</span>
          </span>
        </div>
        <div class="images-column">
          <template v-if="Array.isArray(local)">
            <div
              v-for="(img, i) in local"
              :key="'local-' + i"
              class="image-card"
            >
              <img
                :src="resolveUrl(img)"
                :alt="img.description || img.displayName || 'Local Image'"
                class="image"
              />
              <div class="meta">
                <div class="meta-name" v-if="img.name">{{ img.name }}</div>
                <div class="meta-description" v-if="img.description">
                  {{ img.description }}
                </div>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="image-card">
              <img
                :src="resolveUrl(local)"
                :alt="img.description || img.displayName || 'Local Image'"
                class="image"
              />
            </div>
          </template>
        </div>
      </div>

      <!-- Theirs -->
      <div class="image-set">
        <div class="set-header">
          <span class="set-title">Theirs</span>
          <span class="set-count">
            {{ serverCount }} image<span v-if="serverCount !== 1">s</span>
          </span>
        </div>
        <div class="images-column">
          <template v-if="Array.isArray(server)">
            <div
              v-for="(img, i) in server"
              :key="'server-' + i"
              class="image-card"
            >
              <img
                :src="resolveUrl(img)"
                :alt="img.description || img.displayName || 'Server Image'"
                class="image"
              />
              <div class="meta">
                <div class="meta-name" v-if="img.name">{{ img.name }}</div>
                <div class="meta-description" v-if="img.description">
                  {{ img.description }}
                </div>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="image-card">
              <img
                :src="resolveUrl(server)"
                :alt="img.description || img.displayName || 'Server Image'"
                class="image"
              />
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ConflictImagesField',
  props: {
    local: { type: [Array, Object, String], default: () => [] },
    server: { type: [Array, Object, String], default: () => [] },
    resolved: { type: String, default: '' },
    module: { type: String, default: 'publisher' },
  },
  computed: {
    localCount() {
      return Array.isArray(this.local) ? this.local.length : 1;
    },
    serverCount() {
      return Array.isArray(this.server) ? this.server.length : 1;
    },
  },
  methods: {
    resolveUrl(img) {
      if (!img) return '';

      console.log('resolveUrl', img);
      let imageUrl = typeof img === 'string' ? img : img.url || img.path || img;

      if (!imageUrl) return '';

      if (imageUrl[0] !== '/') {
        imageUrl = `/${imageUrl}`;
      }

      if (imageUrl && window.location.host.includes('localhost')) {
        return `http://localhost:4566/images${imageUrl}`;
      }

      return imageUrl || '';
    },
  },
};
</script>

<style scoped>
.conflict-images-wrapper {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.image-columns {
  display: flex;
  flex-direction: row;
  gap: 2rem;
  flex-wrap: wrap;
}

.image-set {
  flex: 1;
  min-width: 280px;
  display: flex;
  flex-direction: column;
}

.set-header {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  font-weight: 600;
  border-bottom: 1px solid #ddd;
  padding-bottom: 4px;
  margin-bottom: 0.5rem;
  font-size: 0.95rem;
}

.set-title {
  font-size: 1.05rem;
  font-weight: 600;
  color: #363636;
}

.set-count {
  font-size: 0.85rem;
  color: #7a7a7a;
}

.images-column {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.image-card {
  background: #fff;
  border-radius: 6px;
  padding: 0.5rem;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);
  transition: transform 0.2s ease;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.image-card:hover {
  transform: scale(1.01);
}

.image {
  width: 100%;
  max-height: 120px;
  object-fit: contain;
  border-radius: 4px;
  border: 1px solid #ccc;
  background: #f9f9f9;
}

/* fix: preserve space even if name/desc are missing */
.meta {
  min-height: 2.75rem; /* enough for 2 lines */
  text-align: center;
  font-size: 0.8rem;
  color: #4a4a4a;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.meta-name {
  font-weight: 600;
}

.meta-description {
  font-style: italic;
  color: #888;
}
</style>
